import { defineStore } from "pinia";
import _get from "lodash/get";
import _snakeCase from "lodash/snakeCase";

export const useI18nStore = defineStore("I18nStore", {
  // state
  state: () => {
    return {
      messages: {},
    };
  },

  // getters

  getters: {
    $raw:
      ({ messages }) =>
      (locale: string, key: string, count?: number) => {
        const localeMessages = _get(messages, locale, {});
        const localeMessage = _get(localeMessages, key, `${locale}.${key}`);
        if (typeof count === "undefined") return localeMessage.trim();
        const msgParts = localeMessage.split("|");
        const msgIndex = Math.max(Math.min(count, msgParts.length - 1, 2), 0);
        return msgParts[msgIndex].trim();
      },
    $t:
      () =>
      (
        locale: string,
        key: string,
        object?: Record<string, string | undefined>
      ) => {
        return useI18nStore()
          .$raw(locale, key)
          .replace(/\{(\w+)\}/gm, function (_: string, key: string) {
            return object?.[key] || "";
          })
          .trim();
      },
    $tc:
      () =>
      (
        locale: string,
        key: string,
        count: number,
        object?: Record<string, string>
      ) => {
        return useI18nStore()
          .$raw(locale, key, count)
          .replace(/\{(\w+)\}/gm, function (_: string, key: string) {
            const computedObj = { count: `${count}`, ...object, n: `${count}` };
            return _get(computedObj, key, "");
          })
          .trim();
      },
  },
});
